import {
  GetFinalityLogsRequest,
  GetFinalityLogsResponse
} from "../../../domain/repositories/FinalityRepository";

import {
  TRIGGER_GET_FINALITY_LOGS,
  TriggerGetFinalityLogs,

  GET_FINALITY_LOGS_PENDING,
  GetFinalityLogsPending,

  GET_FINALITY_LOGS_SUCCESS,
  GetFinalityLogsSuccess,

  GET_FINALITY_LOGS_ERROR,
  GetFinalityLogsError,

  RESET_GET_FINALITY_LOGS,
  ResetGetFinalityLogs
} from "./types";

export const triggerGetFinalityLogs = (
  request: GetFinalityLogsRequest
): TriggerGetFinalityLogs => {
  return {
    type: TRIGGER_GET_FINALITY_LOGS,
    payload: { request }
  };
};

export const getFinalityLogsPending = (): GetFinalityLogsPending => {
  return {
    type: GET_FINALITY_LOGS_PENDING
  };
};

export const getFinalityLogsSuccess = (
  response: GetFinalityLogsResponse
): GetFinalityLogsSuccess => {
  return {
    type: GET_FINALITY_LOGS_SUCCESS,
    payload: { response }

  };
};

export const getFinalityLogsError = (): GetFinalityLogsError => {
  return {
    type: GET_FINALITY_LOGS_ERROR,
  };
};

export const resetGetFinalityLogs = (): ResetGetFinalityLogs => {
  return {
    type: RESET_GET_FINALITY_LOGS,
  };
};